import React, { useEffect, useRef, useState } from "react";

// Ghar360 product demo, used on the Ghar360 page and the homepage
export const GHAR360_DEMO_VIDEO_ID = "3V7Zn9UVtZ0";
// ARRISE (AR-Rise) demo, used on the homepage
export const ARRISE_DEMO_VIDEO_ID = "1lC1mLVDuo8";

// YouTube video that loads and plays when it scrolls into view and pauses when it leaves
// (or when its tab is hidden). Browsers only allow autoplay with sound off, so it starts
// muted; the YouTube controls let visitors unmute.
const YouTubeInView = ({ videoId, poster, title, className = "" }) => {
  const boxRef = useRef(null);
  const frameRef = useRef(null);
  const [loaded, setLoaded] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const box = boxRef.current;
    if (!box || !("IntersectionObserver" in window)) {
      setLoaded(true);
      return undefined;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting);
        if (entry.isIntersecting) setLoaded(true);
      },
      { threshold: 0.5 }
    );
    observer.observe(box);
    return () => observer.disconnect();
  }, []);

  const command = (func, args = []) =>
    frameRef.current?.contentWindow?.postMessage(JSON.stringify({ event: "command", func, args }), "*");

  useEffect(() => {
    command(visible ? "playVideo" : "pauseVideo");
  }, [visible]);

  // YouTube turns auto-captions on for muted autoplay; switch them off once the player is up
  const hideCaptions = () => [500, 1500, 3000].forEach((ms) => setTimeout(() => command("unloadModule", ["captions"]), ms));

  const src =
    `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}` +
    "&playsinline=1&rel=0&modestbranding=1&enablejsapi=1&cc_load_policy=0";

  return (
    <div className={className} ref={boxRef}>
      {loaded ? (
        <iframe
          ref={frameRef}
          src={src}
          onLoad={hideCaptions}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      ) : (
        poster && <img src={poster} alt={title} />
      )}
    </div>
  );
};

export default YouTubeInView;
